import { getAssetURL } from "helpers/assets";

const TARALITE_FILE_GCS_PATH = "taralite-com/assets/files";

const complaintProcedureFile = getAssetURL(`${TARALITE_FILE_GCS_PATH}/complaint-procedure.pdf`);
const privacyPolicyFile = getAssetURL(`${TARALITE_FILE_GCS_PATH}/pemberitahuan-privasi.pdf`);
const privacyPolicyFileEnglish = getAssetURL(`${TARALITE_FILE_GCS_PATH}/privacy-notice.pdf`);
const oldPrivacyPolicyFile = getAssetURL(`${TARALITE_FILE_GCS_PATH}/privacy-policy.pdf`);
const termsConditionsFile = getAssetURL(`${TARALITE_FILE_GCS_PATH}/terms-condition.pdf`);
const getFraudFilePath = (language) => getAssetURL(`${TARALITE_FILE_GCS_PATH}/fraud-${language}.pdf`);

export { complaintProcedureFile, privacyPolicyFile, privacyPolicyFileEnglish, oldPrivacyPolicyFile, termsConditionsFile, getFraudFilePath };
